/** Autenticación del staff — contracts.md §1. */
import { z } from "zod";
import { USER_ROLES, USER_STATUSES } from "../enums.js";
import { objectId } from "./base.js";
export const password = z.string().min(8, "La contraseña necesita al menos 8 caracteres").max(200);
export const email = z.string().trim().toLowerCase().email();
export const loginBody = z.object({ email, password: z.string().min(1).max(200) });
/** `user` que devuelven login, 2fa y `/api/me` (contracts.md §1). */
export const authUser = z.object({
    id: objectId,
    name: z.string(),
    email: z.string(),
    role: z.enum(USER_ROLES),
    assignedBranchIds: z.array(objectId),
    stockController: z.boolean(),
    status: z.enum(USER_STATUSES),
    /** `/api/me` lo informa para «Mi cuenta»: si ya cargó su PIN de fichaje (RN-ACC-21). */
    hasPin: z.boolean().optional(),
});
export const tokenPair = z.object({
    accessToken: z.string(),
    refreshToken: z.string(),
});
export const loginResponse = z.union([
    tokenPair.extend({ user: authUser }),
    /** owner/admin con 2FA por email (RN-ROL-17). */
    z.object({ twoFactorRequired: z.literal(true), challengeId: z.string() }),
]);
export const twoFactorBody = z.object({
    challengeId: z.string().min(1),
    code: z.string().regex(/^\d{6}$/, "El código son 6 dígitos"),
});
export const refreshBody = z.object({ refreshToken: z.string().min(1) });
export const logoutBody = z.object({ refreshToken: z.string().min(1) });
export const forgotPasswordBody = z.object({ email });
export const resetPasswordBody = z.object({ token: z.string().min(1), password });
/** PIN corto para excepciones en el semáforo y fichaje (RN-ACC-14, RN-ACC-21). */
export const pinVerifyBody = z.object({
    userId: objectId,
    pin: z.string().regex(/^\d{4,8}$/, "El PIN son 4 a 8 dígitos"),
});
export const pinVerifyResponse = z.object({
    ok: z.boolean(),
    userId: objectId,
    role: z.enum(USER_ROLES),
});
/**
 * `POST /api/me/pin` — la persona cambia SU PIN de fichaje desde «Mi cuenta» (RN-ACC-21,
 * RN-PRO-06). Pide la contraseña actual: una sesión abierta y olvidada en un mostrador no
 * alcanza para cambiarle el PIN a nadie.
 */
export const changeMyPinBody = z.object({
    pin: z.string().regex(/^\d{4,8}$/, "El PIN son 4 a 8 dígitos"),
    currentPassword: z.string().min(1, "Falta tu contraseña actual").max(200),
});
/** `DELETE /api/me/sessions/:sessionId` — cerrar una sesión propia (RN-ROL-17). */
export const mySessionParams = z.object({ sessionId: objectId });
/** `POST /api/me/active-branch` — el cambio se audita (RN-ROL-08). */
export const activeBranchBody = z.object({ branchId: objectId });
/** Contenido del JWT de acceso (15 min). */
export const accessTokenClaims = z.object({
    sub: objectId,
    role: z.enum(USER_ROLES),
    /** Id de la sesión persistida en `sessions`: lo que la hace revocable. */
    sid: z.string(),
    kind: z.literal("staff"),
});
//# sourceMappingURL=auth.js.map